import React, { useRef, useState } from 'react';
import QRCode from 'qrcode.react';
import * as htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';
import { Button, Input } from 'antd';
import { DownloadOutlined, LinkOutlined, ShopOutlined } from '@ant-design/icons';
import './QRCodeGenerator.css';
import { useLocation } from 'react-router-dom';

/**
 * 静态收款码预览下载
 * 
 */
const QRCodeGenerator = () => {
  const location = useLocation();
  const { url: initialUrl, merchantName: initialMerchantName } = location.state || {};

  console.log("codeUrl", initialUrl);
  console.log("merchantName", initialMerchantName);

  const [url, setUrl] = useState(initialUrl || '');
  const [MerchantName, setMerchantName] = useState(initialMerchantName);
  const qrCodeRef = useRef(null);

  /**
   * 点击下载时，通过html-to-image将qrCodeRef.current
   *  DOM元素转换为png图片，然后使用file-saver
   *  将其保存到本地
   */
  const handleDownloadClick = () => {
    const node = qrCodeRef.current;

    htmlToImage.toPng(node)
      .then(function (dataUrl) {
        saveAs(dataUrl, MerchantName + '-TOAMTO PAY-QRCODE.png');
      })
      .catch(function (error) {
        console.error('Error generating image:', error);
      });
  };

  return (
    <div style={{ marginLeft: '10px', marginTop: '40px' }}>
      <Input
        prefix={<LinkOutlined style={{ color: '#bfbfbf' }} />}
        placeholder="Please enter the QR code link"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        style={{ 
          marginBottom: '20px', 
          width: '400px',
        }}
        size="large"
      />
      <Input
        prefix={<ShopOutlined style={{ color: '#bfbfbf' }} />}
        placeholder="Please enter the merchant name"
        value={MerchantName}
        onChange={(e) => setMerchantName(e.target.value)}
        style={{ 
          marginBottom: '20px', 
          width: '400px',
        }}
        size="large"
      />
      <div className="backgroundDiv" ref={qrCodeRef}>
        <div style={{ 
          marginTop: '142px', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'space-evenly', 
          height: 280 
        }}>
          <h5 style={{ height: 30, textAlign: 'center', fontSize: '18px' }}>{MerchantName}</h5>
          <QRCode 
            value={url} 
            style={{ 
              marginLeft: 'auto', 
              marginRight: 'auto',
              marginTop: '-10px'
            }} 
            size={180} 
          />
        </div>
      </div>
      <Button 
        type="primary"
        icon={<DownloadOutlined />}
        onClick={handleDownloadClick}
        size="large"
        style={{ 
          marginLeft: '130px', 
          marginTop: '15px',
        }}
      >
        Download QR Code
      </Button>
    </div>
  );
};

export default QRCodeGenerator;
